const S3_URL = process.env.REACT_APP_LANGUAGE_BASE_URL;
const KEY_ETAG = "i18n_etag";
const KEY_DATA = "i18n_data";

const withCacheBuster = (url) => {
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}t=${Date.now()}`;
};

export const loadCachedTranslations = () => {
  const raw = localStorage.getItem(KEY_DATA);
  return raw ? JSON.parse(raw) : null;
};

export const fetchAndCacheTranslations = async () => {
  try {
    const bustUrl = withCacheBuster(S3_URL);

    const head = await fetch(bustUrl, { method: "HEAD", cache: "no-store" });
    const newEtag = head.headers.get("etag");
    const savedEtag = localStorage.getItem(KEY_ETAG);

    if (newEtag && newEtag === savedEtag) return null; // unchanged

    const res = await fetch(bustUrl, { cache: "no-store" });
    const json = await res.json();

    localStorage.setItem(KEY_DATA, JSON.stringify(json));
    if (newEtag) localStorage.setItem(KEY_ETAG, newEtag);

    return json;
  } catch (e) {
    console.warn("i18n sync failed", e);
    return null;
  }
};

export const ensureLanguageCached = async (lang) => {
  if (lang === "en") return;
  const cached = loadCachedTranslations();
  if (cached?.[lang]) return;
  await fetchAndCacheTranslations();
};